import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk'
import dataFetchingReducer from '../features/dataFetching/dataFetchingSlice';
import errorReducer from '../features/error/errorSlice';
import customerReducer from '../features/customer/customerSlice';
import regulationReducer from '../features/regulation/RegulationAcceptanceSlice';
import quantityReducer from '../features/quantityCorrectionsProposals/QuantityCorrectionsProposalsSlice';
import api from './middlewares/api';
import productsReducer from '../features/products/productSlice';
import complaintPositionReducer from '../features/complaintPosition/ComplaintPositionSlice';
import searchReducer from '../features/searchComplaint/SearchComplaintSlice';
import fileReducer from '../features/files/FileSlice';
import complaintTypesReducer from '../features/complaintTypes/ComplaintTypesSlice';
import complaintReducer from '../features/complaint/ComplaintSlice';
import complaintPositionComponentsReducer from '../features/complaintPositionsComponents/ComplaintPositionsComponentsSlice';
import complaintPositionsReducer from '../features/complaintPositions/ComplaintPositionsSlice';
import companyReducer from '../features/customer/companySlice';
import couriersReducer from '../features/couriers/couriersSlice';
import shippingMethodReducer from '../features/shippingMethod/shippingMethodSlice';
import targetCustomerReducer from '../features/customer/targetCustomerSlice';
import captchaReducer from '../features/captcha/CaptchaSlice';
import attachmentReducer from '../features/hasAttachments/HasAttachmentsSlice';

export const store = configureStore({
  reducer: {
    dataFetching: dataFetchingReducer,
    error: errorReducer,
    captcha: captchaReducer,
    company: companyReducer,
    complaint: complaintReducer,
    complaintTypes: complaintTypesReducer,
    complaintPosition: complaintPositionReducer,
    couriers: couriersReducer,
    customer: customerReducer,
    complaintPositions: complaintPositionsReducer,
    complaintPositionComponents:complaintPositionComponentsReducer,
    shipping: shippingMethodReducer,
    terms: regulationReducer,
    products: productsReducer,
    searchComplaint: searchReducer,
    quantity: quantityReducer,
    files: fileReducer,
    targetCustomer: targetCustomerReducer,
    attachment: attachmentReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(thunkMiddleware).concat(api),
  devTools: process.env.NODE_ENV !== 'production', //devtool tylko na debug
});

export default store;
